import { render } from "./Log.vue?vue&type=template&id=061f24cd&scoped=true&ts=true"
import script from "./Log.vue?vue&type=script&lang=ts"
export * from "./Log.vue?vue&type=script&lang=ts"

import "./Log.vue?vue&type=style&index=0&id=061f24cd&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061f24cd"]])

export default __exports__